/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { fetchChatMemberAsync, setChats, setSelectedUser } from "../../../../ReduxToolkit/Reducers/Messenger/Chat";
import { ChatMembersType, ChatsTypes } from "../../../../Types/MessengerType";
import Chat from "./Chat";
import ChatHeader from "./ChatHeader";
import MessageInput from "./MessageInput";

const PrivateChat = () => {
  const { subChatActiveTab } = useAppSelector((state) => state.messenger);
  const { allMembers, chats } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  const fetchChatAsync = () => {
    if (chats.length > 0) {
      if (subChatActiveTab === "direct") {
        const selectedUser = chats.find((x: ChatsTypes) => x.id === 3);
        const oneSelect = allMembers.find((x: ChatMembersType) => x.id === selectedUser?.id);
        if (allMembers.length > 0) {
          dispatch(setChats(chats));
          dispatch(setSelectedUser(oneSelect));
        }
        if (allMembers.length > 0) allMembers.find((x: ChatMembersType) => x.id === selectedUser?.id);
      } else {
        const selectedUser = chats.find((x: ChatsTypes) => x.id === 8);
        const oneSelect = allMembers.find((x: ChatMembersType) => x.id === selectedUser?.id);
        if (allMembers.length > 0) {
          dispatch(setChats(chats));
          dispatch(setSelectedUser(oneSelect));
        }
        if (allMembers.length > 0) allMembers.find((x: ChatMembersType) => x.id === selectedUser?.id);
      }
    }
  };
  useEffect(() => {
    dispatch(fetchChatMemberAsync());
    fetchChatAsync();
  }, [dispatch, allMembers.length, chats.length, subChatActiveTab]);
  return (
    <div className={`messages custom-scroll ${subChatActiveTab === "direct" ? "active" : ""}`}>
      <ChatHeader />
      <Chat />
      <MessageInput />
    </div>
  );
};

export default PrivateChat;
